module.exports = __webpack_public_path__ + "assets/img/illust_04.f6bcd43b.png";